import { Css, useTestIds } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { AddOrModifyOptionsFormInput } from "../addOrModifyOptionsWorkflow";

type SelectedOptionsPaneProps = { formState: ObjectState<AddOrModifyOptionsFormInput> };

/**
 * The right pane's running list of what the selection adds to and removes from the project's configuration.
 *
 * TODO: list the added/removed options once the step renders them.
 */
export function SelectedOptionsPane(props: SelectedOptionsPaneProps) {
  const tid = useTestIds(props, "selectedOptions");
  return (
    <div css={Css.sm.gray700.$} {...tid.emptyState}>
      Changes will be populated here when options are modified to the left.
    </div>
  );
}
